import { D as DialogExt } from './dialog-BxVV6X1H.js';
import './focus-trap.esm-C-N_-G0z.js';
import './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class DrawerElement extends DialogExt {
  open() {
    // Call super first to run the logic in the parent class
    super.open();
    // Close the drawer when the window is resized
    window.addEventListener('resize', () => super.close(), { once: true });
  }
}

customElements.define('drawer-element', DrawerElement);
